/* eslint-disable */
export default function registerBindShare($, apower) {
// relative with a layer with class name, especially when the trigger and layer are not in same place
  $.registerDir('layer', {

    align: 't',

    gap: '0',

    open: false,

    triggerType: 'hover',

    layer: null,

    hasTransformAndTransition: false,

    selector: '[data-layer]',

    trangle: true,
    // delaytime:'0',
    //
    time: '',

    init () {
      let value = this.layer || this.el.attr('data-layer')

      if (typeof value === 'string') {
        let className = (value.startsWith('.') ? '' : '.') + value
        let el = this.el[0]
        let layer = this.el.find(className)[0] || this.el.findNearestBehind(className)[0]

        this.layer = $(layer)
      }

      this.hasTransformAndTransition = this.layer.css('transition').includes('transform') || this.layer.css('transform').select(/\d+/) == '0'

      if (!this.layer.find('.ap-trangle').length && this.trangle) {
        this.layer.prepend('<div class="ap-trangle"></div>')
      }

      if (this.triggerType === 'hover') {
        this.el.on('mouseenter', this.onMouseEnter, this)
      }
      else {
        this.el.on(this.triggerType, this.onClick, this)
      }
    },

    unbind () {
      this.el.off('mouseenter', this.onMouseEnter, this)
    },

    onMouseEnter () {
      this.showLayer()
    },

    onClick () {
      if (this.open) {
        this.hideLayer()
      }
      else {
        this.showLayer()
      }
    },

    showLayer () {
      if (this.open) {
        return
      }

      if (this.hasTransformAndTransition) {
        this.layer.css('transform', 'none')
        this.layer.css('transition', 'none')
      }

      this.time = this.el.attr('data-time') || 300


      if(this.time){
        this.layer.fadeIn(parseInt(this.time))
      }
      else{
        this.layer.fadeIn()
      }

      this.layer.alignTo(this.el, this.align, this.gap)

      if (this.hasTransformAndTransition) {
        this.layer.css('transform', '')
        this.layer[0].offsetWidth
        this.layer.css('transition', '')
        this.layer.css('transform', 'none')
      }
      else {
        this.layer.hide()
        this.layer.fadeIn(300)
      }

      this.el.addClass('active')
      this.open = true

      $.onceAllLeave(this.el[0].contains(this.layer[0]) ? [this.el] : [this.el, this.layer], 200, this.hideLayer, this)
    },

    hideLayer () {
      if (this.hasTransformAndTransition) {
        this.layer.css('transform', '')
      }
      else {
        this.layer.fadeOut(300)
      }

      this.el.removeClass('active')
      this.open = false
    },
  })
  //global share registration, used on many coms
  $.registerDir('bind-share', {

    selector: '[data-share], .apower-counted-share',

    props: ['share', 'share-url', 'share-title', 'align', 'gap', 'use-apower-qrcode'],

    share: '',

    shareUrl: '',

    shareTitle: '',

    align: 'r',

    gap: 10,

    init: function () {
      var re = new RegExp(Object.keys(this.links).join('|'))

      this.el.$on('click', function (e) {
        var name = this.share

        if (!name) {
          var li = $(e.target).closest('li')[0]

          if (li) {
            name = li.className.select(re, 0)
          }
        }

        if (name) {
          this.shareTo(name, this.shareUrl, this.shareTitle, '', li)
        }
      }, this)

      this.el.find('li').$on('mouseenter', function (e) {
        var li = $(e.target).closest('li')[0]

        if (li) {
          name = li.className.select(re, 0)
        }

        if (name && this.links[name].img) {
          this.shareTo(name, this.shareUrl, this.shareTitle, '', li)
        }
      }, this)
    },

    links: {
      google : {
        url: 'https://plus.google.com/share?url={url}&t={title}',
        width: 500,
        height: 500,
      },

      facebook : {
        url: 'http://www.facebook.com/sharer/sharer.php?u={url}&title={title}',
        width: 673,
        height: 374,
      },

      twitter : {
        url: 'https://twitter.com/intent/tweet?url={url}&text={title}',
        width: 548,
        height: 430,
      },

      pinterest : {
        url: '//assets.pinterest.com/js/pinmarklet.js',
        append: true,
        width: 600,
        height: 400,
      },

      hatena: {
        url: 'http://b.hatena.ne.jp/entry/panel/?url={url}&btitle={title}',
        width: 365,
        height: 220,
      },

      linkedin: {
        url: 'https://www.linkedin.com/shareArticle?mini=true&url={url}&title={title}',
        width: 600,
        height: 600,
      },

      weixin: {
        img : '/do.php?action=qrcode&data={url}&size=5',
      },

      douban: {
        url : 'http://www.douban.com/share/service?href={url}&name={title}&text={text}',
      },

      qzone: {
        url: 'http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url={url}&title={title}&desc={text}&summary=&site='
      },

      weibo: {
        url : 'http://service.weibo.com/share/share.php?url={url}&title={title}&searchPic=true',
      },

      tencent: {
        url: 'http://share.v.t.qq.com/index.php?c=share&a=index&url={url}&title={title}',
      },

      youdao: {
        url: 'http://note.youdao.com/memory/?url={url}&title={title}',
      }
    },

    getShareLink: function (name, url, title, text) {
      var link = this.links[name].url || this.links[name].img

      if (name === 'weixin') {
        link = apower.getDomain('zh') + link
      }

      var o = {
        url   : encodeURIComponent(url),
        title : encodeURIComponent(title),
        text  : encodeURIComponent(text),
      }

      link = link.format(o)

      return link
    },

    onopenparams: null,

    shareTo: function (name, url, title, text, btn) {
      var $btn = $(btn)

      url   = url   || location.href
      title = title || $btn.data('share-title') || document.title
      text  = text  || $btn.data('share-text')  || ''

      if (typeof this.links[name] === 'function') {
        this.links[name](url, title, text, $btn)
      }
      else {
        var link = this.getShareLink(name, url, title, text)

        if (this.links[name].append) {
          $('body').append('<script src="' + link + '"></script>')
        }
        else if (this.links[name].url) {
          var width = this.links[name].width
          var height = this.links[name].height
          var params = ''

          if (width && height) {
            params = 'width=' + width + ',height=' + height
          }

          if (this.onopenparams) {
            params = this.onopenparams(params, name)
          }

          window.open(link, 'share-to-' + name, params)
        }
        else if (!$btn.dir('layer')) {
          var layer = $.newCom('layer', $btn, {
            align: this.align,
            gap: this.gap,
            layer: $('<div class="ap-qrcode"><img src="'+ link +'"></div>').appendTo('body'),
          })

          layer.showLayer()
        }
      }
    }
  })
}